import {cast, flow, getSnapshot, Instance, types} from 'mobx-state-tree';
import {TTree} from '@progress-fe/ui-kit';
import {TechProcessApi, TreeInfo} from 'api';
import {ResetModel, RequestModel} from 'core/models';

const TreeCatalog = types.compose(
  ResetModel,
  types
    .model('TreeCatalog', {
      entities: types.optional(types.array(types.frozen<TTree>()), []),
      fetchEntitiesRequest: types.optional(RequestModel, {})
    })
    .actions((self) => ({
      load: flow(function* (projectUuid: string, checkpointUuid: string) {
        const response: TreeInfo = yield self.fetchEntitiesRequest.send(
          TechProcessApi.techProcessGetPropsTree.bind(TechProcessApi),
          {
            projectUuid: projectUuid,
            checkpointUuid: checkpointUuid
          }
        );

        self.entities = cast(response.trees as Array<TTree>);
      })
    }))
    .views((self) => ({
      get trees(): Array<TTree> {
        return getSnapshot(self.entities);
      }
    }))
);

export type TTreeCatalogModel = Instance<typeof TreeCatalog>;

export {TreeCatalog};
